var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-clickable',{staticClass:"expand",on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('img',{class:{ expanded: _vm.expanded, right: _vm.right },attrs:{"src":require("./assets/expand.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }